import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'
import { Skeleton } from 'antd'

import Sidebar from '@/components/Sidebar'
import Headbar from '@/components/Headbar'

const MainLayout = () => {
  return (
    <div className='flex h-screen bg-surface'>
      <Sidebar />
      <div className='flex flex-1 flex-col'>
        <Headbar />
        <main className='flex-1 overflow-hidden'>
          <Suspense fallback={<Skeleton active />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  )
}

export default MainLayout
